export const LOADING = "DOCUMENTS-LOADING";
export const DOCUMENTS = "DOCUMENTS-DOCUMENTS";
export const PARENTID = "DOCUMENTS-PARENTID";
export const BREADCRUMB = "DOCUMENTS-BREADCRUMB";
export const FOLDER = "DOCUMENTS-FOLDER";
export const VIRTUAL = "DOCUMENTS-VIRTUAL";